import { useTranslation, Trans } from '@/locales';
import { StyledLink } from '@/components/StyledSharedComponents/StyledLink';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import {
  StyledTypography,
  StyledWrapper,
} from '@/views/NoPermissionsView/NoPermissionsView.styled';

export const NoPermissionsView = () => {
  const { t } = useTranslation('common');
  const { isDesktop } = useBreakpointsCtx();
  return (
    <StyledWrapper isDesktop={isDesktop}>
      <StyledTypography>
        <Trans
          t={t}
          i18nKey="no-permission"
          components={{
            br: <br />,
            StyledLink: <StyledLink to="mailto:contact@agioratings.io" />,
          }}
        />
      </StyledTypography>
    </StyledWrapper>
  );
};
